import React from "react";

import PropTypes from "prop-types";

import IconButton from "@cayuse/shared-react.components.icon-button";

import PercentTextInput from "components/PercentTextInput";
import SearchBar from "components/SearchBar";
import { useDictionary } from "hooks";

import styles from "./styles.css";

const ClassificationCodePreview = ({ label, includePercentage, isRequired, codeType }) => {
	const { [codeType.toLowerCase()]: dictionary, common } = useDictionary("classificationCodes");

	return (
		<div className={styles.forCodeContainer}>
			<div className={styles.labelGroup}>
				<div className={styles.labelGroupTitle}>
					<span data-required={isRequired}>{label}</span>
					{isRequired && <span>{common.required}</span>}
				</div>
				<div className={`${styles.row} ${styles.rowNowrap}`}>
					<span data-required={isRequired}>{dictionary.searchLabel}</span>
					{includePercentage && <span data-required={isRequired}>{common.percentOfResearch}</span>}
				</div>
			</div>
			<div className={styles.row}>
				<div className={styles.rowField}>
					<SearchBar className={styles.codeSearch} options={[]} disabled />
				</div>
				{includePercentage && (
					<div className={styles.rowField}>
						<PercentTextInput value="" className={styles.percentageInput} disabled />
					</div>
				)}
			</div>
			<div className={styles.codeFieldsActions}>
				<div>
					<IconButton icon="plus" primary disabled={true} className={styles.addButton}>
						{dictionary.addLabel}
					</IconButton>
				</div>
			</div>
		</div>
	);
};

ClassificationCodePreview.defaultProps = {
	codeType: "FOR",
	isRequired: false,
	includePercentage: true,
};

ClassificationCodePreview.propTypes = {
	codeType: PropTypes.oneOf([ "FOR", "HERDC", "SEO", "TOA" ]),
	label: PropTypes.string,
	isRequired: PropTypes.bool,
	includePercentage: PropTypes.bool,
};

export default ClassificationCodePreview;
